import { Suspense, useEffect, useState } from "react"
import { AuthProvider as OidcProvider } from "react-oidc-context"

import { PageTitle } from "@/components/page-title"
import { AccessGate } from "@/routes/gates"
import { AuthProvider } from "@/contexts/auth-context"
import { BudgetDataProvider } from "@/contexts/budget-data-context"
import { UserProvider } from "@/contexts/user-context"
import { oidcConfig } from "@/lib/oidc"
import { Providers } from "@/providers"
import { AppRoutes } from "@/routes"
import { env } from "@/shared/config/env"
import { Toaster as Sonner } from "@/components/ui/sonner"
import { Toaster } from "@/components/ui/toaster"
import { onShowErrorOverlay, onHideErrorOverlay, hideErrorOverlay } from "@/shared/error-overlay"
import { toast } from "sonner"

function useFixRadixPointerEvents() {
  useEffect(() => {
    const observer = new MutationObserver(() => {
      if (document.body.style.pointerEvents === "none" && !document.querySelector("[data-radix-dialog-overlay], [data-radix-alert-dialog-overlay]")) {
        document.body.style.pointerEvents = ""
      }
    })
    observer.observe(document.body, { attributes: true, attributeFilter: ["style"] })
    return () => observer.disconnect()
  }, [])
}

function ErrorOverlay() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const unsubShow = onShowErrorOverlay(() => setVisible(true))
    const unsubHide = onHideErrorOverlay(() => setVisible(false))
    return () => { unsubShow(); unsubHide() }
  }, [])

  if (!visible) return null

  return <div data-error-overlay className="fixed inset-0 bg-black/40 z-[99998]" />
}

function AppContent() {
  useFixRadixPointerEvents()
  return (
    <AuthProvider>
      <UserProvider>
        <AccessGate>
          <BudgetDataProvider>
            <Providers>
              <PageTitle />
              <Suspense
                fallback={
                  <div className="fixed inset-0 flex items-center justify-center bg-background">
                    <div className="flex items-center gap-3">
                      <div className="h-5 w-5 animate-spin rounded-full border-2 border-muted-foreground/30 border-t-primary" />
                      <span className="text-sm text-muted-foreground">Yükleniyor...</span>
                    </div>
                  </div>
                }
              >
                <AppRoutes />
              </Suspense>
              <Toaster />
              <Sonner />
              <ErrorOverlay />
            </Providers>
          </BudgetDataProvider>
        </AccessGate>
      </UserProvider>
    </AuthProvider>
  )
}

function App() {
  // In bypass/mock mode, skip OIDC provider
  if (env.VITE_AUTH_BYPASS) {
    return <AppContent />
  }

  return (
    <OidcProvider {...oidcConfig}>
      <AppContent />
    </OidcProvider>
  )
}

export default App
